export default "__VITE_ASSET__DYMEu348__"